export enum Side {
  Left = 'left',
  Right = 'right'
}

export type Width = {
  default: number | string;
  min: number | string;
  max: number | string;
};
